export default __webpack_public_path__ + "static/media/critical.b11c1019.svg";